import { AppState } from 'Store'

const getArticleAccessUserId = (state: AppState) => state.knowledge.access.user
const getArticleAccessData = (state: AppState) => state.knowledge.access.data

export const accessSelector = {
	getArticleAccessUserId,
	getArticleAccessData,
}
